import { 
    Box,
    Button, 
    Drawer, 
    DrawerBody, 
    DrawerCloseButton, 
    DrawerContent, 
    DrawerFooter, 
    DrawerHeader, 
    DrawerOverlay, 
    FormControl, 
    FormLabel, 
    Input, 
    Stack, 
    Text, 
    Image,
    useToast, 
} from "@chakra-ui/react";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { FiSave, FiTrash2 } from 'react-icons/fi'
import Select from 'react-select'

import { 
    updateObjectApplication,
    postObjectApplication,
    deleteObjectApplication,
    getObjectApplicationById,
    getProducts
} from "../../../Api/IncidentManagement";
import { IFormProps, ICommonProps } from "../Common/interfaces";
import { useAuth } from "../../../Hook/useAuth";
import { ICreateObjectApplication } from "./interface";


export function ObjectApplicationForm({ isOpen, setIsOpen, handleReloadTable, id }: IFormProps) {
    const [loading, setLoading] = useState(false)
    const [showLogoPreview, setShowLogoPreview] = useState(false)
    const [iconUrl, setIconUrl] = useState('')
    const toast = useToast()   
    const { accessToken } = useAuth() 
    const [application, setApplication] = useState([])

    const formik = useFormik({
        initialValues: {
            name: '',
            applicationId: 0,
            file: []
        },
        validate: values => {
            let errors = {} as any
            if(!values.name) {
                errors.name = "Este campo é obrigatório"
            }

            if(!values.applicationId) {
                errors.locationId = "Este campo é obrigatório"
            }

            /*if(!values.file || values.file.length === 0) {
                errors.file = "Este campo é obrigatório"
            }*/

            return errors;
        },
        onSubmit: async (values: ICreateObjectApplication, { setSubmitting }) => {
            debugger;
            if(loading) {
                return
            }

            let payload = {} as ICreateObjectApplication
            Object.entries(values).forEach(([key, value]) => {
                if(value) {
                    payload = {
                        ...payload,
                        [key]: value
                    }
                }
            })

            let data = new FormData();
            data.append("name", payload.name);
            data.append("applicationId", payload.applicationId.toString());
            data.append("logo", (values.file[0] || null));

            try {
                let response = null
                if(id) {
                    response = await updateObjectApplication({id: id, data: data}, accessToken)
                } else {
                    response = await postObjectApplication(data, accessToken)
                }
                
                if(response.status === 200) {
                    formik.resetForm()
                    handleReloadTable()

                    toast({
                        title: 'Sistema',
                        description: "Operação bem sucedida!",
                        status: 'success',
                        duration: 9000,
                        isClosable: true,
                    })
                } else {
                    toast({
                        title: 'Sistema',
                        description: "Ocorreu um erro no registo de sistema!",
                        status: 'error',
                        duration: 9000,
                        isClosable: true,
                    })
                }
            } catch (error) {
                toast({
                    title: 'Sistema',
                    description: "Ocorreu um erro no registo de sistema!",
                    status: 'error',
                    duration: 9000,
                    isClosable: true,
                })
            } finally {
                setSubmitting(false)
            }            
        },
    })

    useEffect(() => {

        const loadProducts = async(token: string) => {
            try {
                const components = await getProducts(token)

                if(components.status === 200) {
                    const componentDropDownOptions= components.data.map((row: ICommonProps) => ({ value: row.id, label: row.name}))
                    setApplication(componentDropDownOptions)
                }

                if(components.status !== 200) {
                    toast({
                        title: 'Produto',
                        description: "Ocorreu ao ler dados!",
                        status: 'error',
                        duration: 9000,
                        isClosable: true,
                    })
                }
            } catch (error) {
                toast({
                    title: 'Produto',
                    description: "Ocorreu ao ler dados!",
                    status: 'error',
                    duration: 9000,
                    isClosable: true,
                })
            }
        }

        if(accessToken) {
            loadProducts(accessToken)
        }
        // eslint-disable-next-line
    }, [accessToken])

    const handleDeleteObjectApplication = async(id: number, token: string) => {
        try {
            setLoading(true)
            const response = await deleteObjectApplication(id, token)

            if(response.status === 200) {
                formik.resetForm()                
                handleReloadTable()

                toast({
                    title: 'Sistema',
                    description: "O registo da applicatione foi eliminado com sistema!",
                    status: 'success',
                    duration: 9000,
                    isClosable: true,
                })
            } else {
                toast({
                    title: 'Sistema',
                    description: "Ocorreu erro ao eliminar sistema!",
                    status: 'error',
                    duration: 9000,
                    isClosable: true,
                })
            }
        } catch (error) {
            toast({
                title: 'Sistema',
                description: "Ocorreu erro ao eliminar sistema!",
                status: 'error',
                duration: 9000,
                isClosable: true,
            })
        } finally {
            setLoading(false)
        }
    }

    const loadObjectApplicationById = async(id: number, token: string) => {
        try {
            setLoading(true);
            const response = await getObjectApplicationById(id, token)
            if(response.status === 200) {

                const {
                    name,
                    applicationID,
                    applicationName,
                    logoUrl
                } = response.data

                if(logoUrl && logoUrl !== ''){
                    setShowLogoPreview(true);
                    setIconUrl(logoUrl);
                }

                await formik.setFieldValue("name", name)
                await formik.setFieldValue("applicationId",applicationID)
            } else {
                toast({
                    title: 'Sistema',
                    description: "Ocorreu erro ao carregar sistema!",
                    status: 'error',
                    duration: 9000,
                    isClosable: true,
                })
            }
        } catch (error) {
            toast({
                title: 'Sistema',
                description: "Ocorreu erro ao carregar sistema!",
                status: 'error',
                duration: 9000,
                isClosable: true,
            })
        }
        finally{
            setLoading(false);
        }
    }

    useEffect(() => {
        if(id && accessToken) {
            loadObjectApplicationById(id, accessToken)
        } else if(!id) {
            setShowLogoPreview(false);
        }

        // eslint-disable-next-line
    }, [id, accessToken])

    return(
        <Drawer
            size="xl"
            isOpen={isOpen}
            placement='right'
            onClose={() => {
                if(loading) {
                    return
                }
                formik.resetForm()
                setIsOpen(!isOpen)
                setShowLogoPreview(false);
                setIconUrl('');
            }}>
            <DrawerOverlay />
            <DrawerContent overflowY="scroll">
                <DrawerCloseButton />

                <DrawerHeader borderBottomWidth='1px'>
                    <Text>Objetos Aplicacionais</Text>
                </DrawerHeader>

                <form onSubmit={formik.handleSubmit}>
                    <DrawerBody overflow="visible">
                        <Stack spacing="4" p="8">
                            <FormControl isRequired>
                                <FormLabel htmlFor="name">Nome</FormLabel>
                                <Input
                                    id="name"
                                    name="name"
                                    maxLength={1000} 
                                    placeholder='Nome' 
                                    onChange={formik.handleChange}
                                    value={formik.values.name}                              
                                />
                                {formik.errors.name && !formik.values.name ? <Text color="red" fontSize='xs'>{formik.errors.name}</Text> : null}
                            </FormControl>
                            <FormControl isRequired>
                                <FormLabel htmlFor="applicationId">Produto</FormLabel>
                                <Select
                                    id="applicationId"
                                    name="applicationId"
                                    placeholder="Produto"
                                    options={application} 
                                    onChange={({ value }: any) => {
                                        formik.setFieldValue('applicationId', value)
                                    }}
                                    value={application.find((row: any) => row?.value === formik.values.applicationId)}
                                />
                                {formik.errors.applicationId && !formik.values.applicationId ? <Text color="red" fontSize='xs'>{formik.errors.applicationId}</Text> : null}
                            </FormControl>
                            <FormControl isRequired={id ? false : true}>
                                <FormLabel htmlFor="file">Logo <span style={{fontSize: "10px"}}>(Apenas são permitidos ficheiros gif, png, jpeg, jpg)</span></FormLabel>
                                <Input
                                    id="file"
                                    name="file"
                                    placeholder="Logo"
                                    accept=".gif,.png,.jpeg,.jpeg2000,.jpg"
                                    onChange={(event) => {
                                        setShowLogoPreview(false);
                                        const file = event.target.files;
                                        formik.setFieldValue("file", file);
                                      }}
                                    type="file"
                                />
                                {formik.errors.file && !formik.values.file ? <Text color="red" fontSize='xs'>{formik.errors.file}</Text> : null}

                            </FormControl>
                            {showLogoPreview && iconUrl !== "" ? 
                                <Box boxSize="12">
                                    <Image borderRadius="full" src={iconUrl} alt="Logo" />
                                </Box>
                              : null
                            }
                        </Stack>
                    
                    </DrawerBody>

                    <DrawerFooter justifyContent="start" px="14">
                        {id ?
                            <Button isLoading={loading} colorScheme="red" leftIcon={<FiTrash2 />} variant='ghost' mr="4" onClick={() => handleDeleteObjectApplication(id, accessToken)}>
                                Remover sistema
                            </Button>
                        : null }
                        <Button isLoading={formik.isSubmitting} type="submit" colorScheme='blue' leftIcon={<FiSave />}>Guardar</Button>                        
                    </DrawerFooter>
                </form>
            </DrawerContent>
        </Drawer>
    )
}